import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  slots = 'PricingSlots',
  slot = 'PricingSlot',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/slot/',
    component: () => import('@/modules/slots/layout/LayoutPage.vue'),
    children: [
      {
        path: '',
        name: MODULE_ROUTE.slots,
        component: () => import('@/modules/slots/pages/PageSlots.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
      {
        path: ':slotId',
        name: MODULE_ROUTE.slot,
        component: () => import('@/modules/slots/pages/PageSlots.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
        props: true,
      },
    ],
  },
];
